// SNIJLAB CUSTOM FILE — shows/hides variant-level certification labels rendered by snippets/product-certifications.liquid.
// Labels carry a "variant-<id>" class per variant that has the certification, plus "certification-hidden" when not shown.
// Impact 7.x dispatches "variant:change" on the product form (event.detail.variant); we listen in the capture phase on
// document so it works whether or not the event bubbles, and fall back to the ?variant= URL parameter.

(function () {
  function showForVariant(variantId) {
    if (!variantId) return;
    document.querySelectorAll('.variant-certification-label').forEach(function (element) {
      element.classList.toggle('certification-hidden', !element.classList.contains('variant-' + variantId));
    });
  }

  function variantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && variant.id) {
      showForVariant(variant.id);
    } else {
      setTimeout(function () { showForVariant(variantFromUrl()); }, 100);
    }
  }, true);

  document.addEventListener('product:rerender', function () {
    setTimeout(function () { showForVariant(variantFromUrl()); }, 100);
  }, true);

  // Popup on hover
  document.addEventListener('mouseover', function (event) {
    var label = event.target.closest && event.target.closest('.certification-label');
    if (label) label.classList.add('hovered_div');
  });
  document.addEventListener('mouseout', function (event) {
    var label = event.target.closest && event.target.closest('.certification-label');
    if (label) label.classList.remove('hovered_div');
  });

  showForVariant(variantFromUrl());
})();
